<h2><i class="fa fa-laptop"></i>{{ 'CREATE_LIVE_STREAM' | translate }}</h2>

<div class="settings-live-stream">
	<div class="live-stream-choice">
		<div class="bb-radio">
			<input type="radio" [id]="'bb'" [(ngModel)]="liveStreamType" name="'bb'" [value]="'bb'">
			<span></span>
		</div>
		<label [for]="'bb'">
			<h3>{{ 'BLUE_BILLYWIG_STREAM' | translate }}</h3>
			<p>{{ 'BLUE_BILLYWIG_STREAM_DESCRIPTION' | translate }}</p>
		</label>
	</div>
	<div class="live-stream-choice">
		<div class="bb-radio">
			<input type="radio" [id]="'thirdparty'" [(ngModel)]="liveStreamType" name="'thirdparty'" [value]="'thirdparty'">
			<span></span>
		</div>
		<label [for]="'thirdparty'">
			<h3>{{ 'THIRD_PARTY_STREAM' | translate }}</h3>
			<p>{{ 'THIRD_PARTY_STREAM_DESCRIPTION' | translate }}</p>
		</label>
	</div>
</div>

<upload-transcode-bb-livestream *ngIf="liveStreamType==='bb' && liveRight"></upload-transcode-bb-livestream>

<p *ngIf="liveStreamType==='bb' && !liveRight" [innerHtml]="'NO_PERMISSIONS_CREATE_BB_STREAM' | translate"></p>

<upload-transcode-thirdparty-livestream *ngIf="liveStreamType==='thirdparty'"></upload-transcode-thirdparty-livestream>